import React from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';

import { secondsToString } from '../../../utils/helpers';
import moment from 'moment';

function StatsBox({
  aiChatHistory,
  date = new Date(),
  disableTalktime = false,
}) {
  const theme = useTheme();

  return (
    <>
      {' '}
      <Box mb={1} color={theme.palette.buzzGreyTextColor}>
        <Typography>
          Total Consumptions for month -{' '}
          <span style={{ color: 'black', fontWeight: 500 }}>
            {' '}
            {moment(date).format('MMM YYYY')}
          </span>
        </Typography>
      </Box>
      <Box
        mb={4}
        width={'96%'}
        border={1}
        display="flex"
        borderColor={theme.palette.buzzBorder}
        p={2}>
        {!disableTalktime && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            flex={1}
            borderRight={`1px solid ${theme.palette.buzzBorder}`}>
            <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
              Total Talktime Duration
            </Box>
            <Box
              minWidth={130}
              display={'flex'}
              justifyContent={'center'}
              fontSize={36}
              fontWeight={'fontWeightMedium'}>
              {secondsToString(
                aiChatHistory
                  .filter(({ createdAt }) =>
                    moment(createdAt).isSame(date, 'month')
                  )
                  .flatMap(({ chats }) => chats)
                  .reduce(
                    (prevVal, { metadata }) =>
                      prevVal +
                      (metadata.promptAudioDuration || 0) +
                      (metadata.answertAudioDuration || 0),
                    0
                  )
              )}
            </Box>
          </Box>
        )}

        <Box display="flex" flexDirection="column" alignItems="center" flex={1}>
          <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
            Total AI Tokens consumed
          </Box>
          <Box
            minWidth={130}
            display={'flex'}
            justifyContent={'center'}
            fontSize={36}
            fontWeight={'fontWeightMedium'}>
            {aiChatHistory
              .filter(({ createdAt }) =>
                moment(createdAt).isSame(date, 'month')
              )
              .flatMap(({ chats }) => chats)
              .reduce(
                (prevVal, { metadata }) => prevVal + (metadata.AItokens || 0),
                0
              )}
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default StatsBox;
